import { useCallback } from "react";
import { toast } from "sonner";

import { citeHit } from "../sources";
import type { LibraryHit } from "../types";

/** Copies an authority's citation, as prose cites it, to the clipboard. */
export const useCopyCitation = () =>
  useCallback(async (hit: Pick<LibraryHit, "title" | "citation" | "date">) => {
    const text = citeHit(hit);
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Citation copied", { description: text });
    } catch {
      toast.error("Couldn't copy the citation");
    }
  }, []);
